import { useEffect, useState } from 'react';

/**
 * Subscribes to a media query and re-renders when it flips.
 * Used to switch off the sticky card-stack choreography on narrow screens,
 * where pinned sections fight with the browser chrome.
 */
export default function useMediaQuery(query) {
    const [matches, setMatches] = useState(() =>
        typeof window !== 'undefined' && window.matchMedia
            ? window.matchMedia(query).matches
            : false
    );

    useEffect(() => {
        if (!window.matchMedia)
            return;

        const list = window.matchMedia(query);
        const onChange = event => setMatches(event.matches);

        setMatches(list.matches);
        list.addEventListener('change', onChange);

        return () => list.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}
